export const AWS_REGIONS: string[] = ['us-west-1', 'us-west-2', 'us-east-1', 'eu-central-1', 'ap-northeast-1', 'cn-north-1'];
